import TmLogo from "@assets/tm_logo.png";
import TmMobileLogo from "@assets/tm_logo_mobile.svg";
import cx from "classnames";

import { HeaderMmLogo } from "./ManavarMurasu/HeaderMmLogo";
export type MmProps = {
  testId: string;
  sectionName?: string;
};

export function HeaderLogo({ testId, sectionName }: MmProps) {
  return (
    <div className="inline-flex m-auto lg:col-start-2 lg:col-span-4 lg:col-end-6 lg:h-20 xs:h-lg">
      <a
        data-testid={`${testId}-logo`}
        href="/"
        rel="home"
        title="Tamil Murasu"
      >
        <img
          alt="Home"
          src={TmLogo}
          className={cx(
            "hidden lg:block",
            sectionName === "maanavar-murasu" ? "h-13 mt-3" : "h-17 mb-2 mt-2",
          )}
        />
        <img
          alt="Home"
          src={TmMobileLogo}
          className="lg:hidden block w-36 mr-1"
        />
      </a>

      {sectionName === "maanavar-murasu" && <HeaderMmLogo />}
    </div>
  );
}
